export default __webpack_public_path__ + "static/media/showVoucherNon.8c746992.jpg";